import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import Footer from "../shared/Footer";
import config from "../../config";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/dataTables.dataTables.css";
import $ from "jquery";
import Swal from "sweetalert2";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";

function ReportsSecondary() {
  const navigate = useNavigate();
  const [selectedReport, setSelectedReport] = useState("");
  const [loading, setLoading] = useState(false);
  const token = sessionStorage.getItem("secondaryaccountstoken");
  const className = sessionStorage.getItem("className");

  useEffect(() => {
    if (!token) {
      navigate("/secondary-accounts-dashboard-class-ix");
    }
  }, [navigate]);

  const reportOptionsClass9 = [
    {
      label: "Pending for Verification",
      url: `${config.API_BASE_URL}/AdminGetFOPendingReportSecondary`,
      method: "GET",
      dataPath: `data["pendingReport_list"]`,
    },
    {
      label: "Verified Payments",
      url: `${config.API_BASE_URL}/AdminGetFOApprovedReportSecondary`,
      method: "GET",
      dataPath: `data["approvedReport_list"]`,
    },
    {
      label: "Rejected Payments",
      url: `${config.API_BASE_URL}/AdminGetFORejectedReportSecondary`,
      method: "GET",
      dataPath: `data["rejectedReport_list"]`,
    },
    {
      label: "Challan Pending for Submission",
      url: `${config.API_BASE_URL}/AdminGetChallanNotPaidReportSecondary`,
      method: "GET",
      dataPath: `data["challanNotPaidReport_list"]`,
    },
    {
      label: "Challan Not Generated",
      url: `${config.API_BASE_URL}/AdminGetChallanNotGenerateReport_CL9`,
      method: "GET",
      dataPath: `data["challanNotGenerateReport_list"]`,
    },
    {
      label: "All Challan Report",
      url: `${config.API_BASE_URL}/AdminGetAllChallanReport_CL9`,
      method: "GET",
      dataPath: `data["allChallanReport_list"]`,
    },
  ];
  const reportOptionsClass10 = [];

  const getSelectedReportConfig = () => {
    const options =
      className === "CLASS_9"
        ? reportOptionsClass9
        : className === "CLASS_10"
          ? reportOptionsClass10
          : [];
    return options.find((r) => r.label === selectedReport);
  };

  const fetchReportData = async () => {
    if (!selectedReport) {
      Swal.fire("Please select a report type.", "", "warning");
      return;
    }

    const config = getSelectedReportConfig();
    if (!config) return;
    if (!token) {
      Swal.fire("Auth Error", "Token is missing. Please login.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(config.url, {
        method: config.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const extractedData = getValueFromPath(result, config.dataPath) || [];

      if (!extractedData.length) {
        Swal.fire("No data found.", "", "info");
        setLoading(false);
        return;
      }

      generateExcel(extractedData, config.label);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Error fetching report.", "error");
    } finally {
      setLoading(false);
    }
  };

  const getValueFromPath = (obj, path) => {
    try {
      return path
        .replace(/\[(["']?)([^\[\]"']+)\1\]/g, ".$2") // convert ["key"] or ['key'] to .key
        .replace(/^\./, "") // remove leading dot
        .split(".")
        .reduce((acc, key) => acc?.[key], obj);
    } catch {
      return undefined;
    }
  };

  const generateExcel = (data, title) => {
    try {
      // Only convert keys to UPPERCASE
      const formatHeader = (key) => key.toUpperCase();

      const headers = ["Sl. No.", ...Object.keys(data[0])];
      const formattedHeaders = [
        "SL. NO.",
        ...Object.keys(data[0]).map(formatHeader),
      ];

      const now = new Date();
      const dateStr = `${String(now.getDate()).padStart(2, "0")}-${String(
        now.getMonth() + 1
      ).padStart(2, "0")}-${now.getFullYear()}  ${now
        .toLocaleTimeString("en-GB", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: true,
        })
        .toUpperCase()}`;

      const ws = XLSX.utils.aoa_to_sheet([
        [`Report: ${title}`],
        [`Generated on: ${dateStr}`],
        [],
        formattedHeaders,
      ]);

      const rows = data.map((item, i) => [
        i + 1,
        ...headers.slice(1).map((key) => item[key] ?? ""),
      ]);

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: formattedHeaders.length - 1 } },
      ];

      ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const safeFileName = `Report_Secondary_${title.replace(
        /[^a-zA-Z0-9]/g,
        "_"
      )}.xlsx`;
      XLSX.writeFile(wb, safeFileName);

      Swal.fire("Success", "Excel file downloaded", "success");
    } catch (err) {
      console.error("Excel generation failed", err);
      Swal.fire("Error", "Failed to generate Excel", "error");
    }
  };
  return (
    <div class="container-scroller">
      <Navbar />
      {loading && (
        <div className="custom-loader-container">
          <div className="custom-loader"></div>
        </div>
      )}
      <div class="container-fluid page-body-wrapper">
        <Sidebar />
        <div class="main-panel">
          <div class="content-wrapper">
            <div class="row">
              <div class="col-md-12 mb-1">
                <section class="content-header">
                  <h1>
                    <i class="fa fa-file"></i>&nbsp;Class{" "}
                    {className === "CLASS_9"
                      ? "IX"
                      : className === "CLASS_10"
                        ? "X"
                        : ""}{" "}
                    Reports
                  </h1>
                  <ol class="breadcrumb">
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          navigate("/secondary-accounts-dashboard-class-ix");
                        }}
                      >
                        <svg
                          stroke="currentColor"
                          fill="currentColor"
                          stroke-width="0"
                          viewBox="0 0 512 512"
                          height="1em"
                          width="1em"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ marginTop: "-4px" }}
                        >
                          <path d="M256 64C132.3 64 32 164.2 32 287.9c0 57 21.3 109 56.3 148.5 1.1 1.2 2.1 2.4 3.2 3.5C96.3 445 103 448 110 448c7.1 0 13.8-3 18.6-8.2 31.6-34.4 77-55.9 127.4-55.9s95.8 21.6 127.4 55.9c4.8 5.2 11.5 8.2 18.6 8.2 7 0 13.7-2.9 18.5-8.1 1.1-1.2 2.1-2.3 3.2-3.5 35-39.5 56.3-91.5 56.3-148.5C480 164.2 379.7 64 256 64zm-14 45.9c0-7.7 6.3-14 14-14s14 6.3 14 14v36c0 7.7-6.3 14-14 14s-14-6.3-14-14v-36zm-128 192H78c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14zm51.5-104.5c-5.4 5.4-14.4 5.4-19.8 0L120.2 172c-5.4-5.4-5.4-14.4 0-19.8s14.4-5.4 19.8 0l25.5 25.5c5.4 5.4 5.4 14.3 0 19.7zm160.6 34.5l-47.5 75.5c-1.9 2.6-4.3 5.1-7 7-13.5 9.7-32.3 6.5-42-7s-6.5-32.3 7-42l75.5-47.5c3.4-2.4 8.1-2.5 11.7 0 4.5 3.2 5.5 9.5 2.3 14zm40.2-34.5c-5.4 5.4-14.4 5.4-19.8 0s-5.4-14.4 0-19.8l25.5-25.5c5.4-5.4 14.4-5.4 19.8 0s5.4 14.4 0 19.8l-25.5 25.5zM434 301.9h-36c-7.7 0-14-6.3-14-14s6.3-14 14-14h36c7.7 0 14 6.3 14 14s-6.3 14-14 14z"></path>
                        </svg>{" "}
                        Home&nbsp;
                      </a>
                    </li>
                    <li class="active">
                      Class{" "}
                      {className === "CLASS_9"
                        ? "IX"
                        : className === "CLASS_10"
                          ? "X"
                          : ""}{" "}
                      Reports
                    </li>
                  </ol>
                  <h3></h3>
                </section>
              </div>
            </div>

            <div className="row" style={{ padding: "0px" }}>
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <label className="mb-2">Select Report Type</label>
                        <select
                          className="form-select "
                          value={selectedReport}
                          onChange={(e) => setSelectedReport(e.target.value)}
                        >
                          <option value="">-- Select Report --</option>
                          {(className === "CLASS_9"
                            ? reportOptionsClass9
                            : className === "CLASS_10"
                              ? reportOptionsClass10
                              : []
                          ).map((opt) => (
                            <option key={opt.label} value={opt.label}>
                              {opt.label}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-md-2 d-flex align-items-end">
                        <button
                          className="btn btn-success"
                          onClick={fetchReportData}
                          disabled={loading}
                        >
                          <i className="fa fa-download"></i> Download Report
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default ReportsSecondary;
